import React, { Component } from "react";
import Select from "react-select";

// const customStyles = {
//   option: (base, state) => ({
//     ...base,
//     borderBottom: "1px dotted pink"
//   }),
//   control: () => ({
//     width: 200
//   }),
//   singleValue: (base, state) => {
//     const opacity = state.isDisabled ? 0.5 : 1;
//     const transition = "opacity 300ms";

//     return { ...base, opacity, transition };
//   }
// };

class SelectEditor extends Component {
  state = {
    value: this.props.value,
  };

  isPopup() {
    return true;
  }

  getValue() {
    return this.state.value;
  }

  handleChangeInSelect = value => {
    if (this.props.fromPopup) {
      this.props.returnValue(value);
    } else {
      this.setState({ value: value.label });
    }
  };

  render() {
    return (
      <Select
        // styles={customStyles}
        options={this.props.values}
        // closeMenuOnSelect={true}
        defaultValue={this.state.value}
        onChange={value => this.handleChangeInSelect(value)}
      />
    );
  }
}

export default SelectEditor;



// WEBPACK FOOTER //
// ./src/components/cell-editors/SelectEditor.js